<fgb-banner [bannerTitle]="'nav.terms' | translate"></fgb-banner>

<fgb-page-header [pageTitle]="'nav.terms'" [backButtonLink]="'/'" [showBalance]="false" [showQr]="false"></fgb-page-header>

<div class="container">
  <fgbcl-terms-and-conditions [type]="termsAndConditionsType" [defaultTerms]="defaultTemplate"></fgbcl-terms-and-conditions>
</div>

<ng-template #defaultTemplate>
  <p class="terms-section-content text-start mb-3">NO TERMS SET</p>
</ng-template>
